import { classNames } from "primereact/utils";
import { useId } from "react";

/**
 * @typedef TabMenuItem
 * @property {string} label
 * @property {string?} icon
 */

/**
 * Renders a tab menu for navigation.
 * @param {object} props
 * @param {Array<TabMenuItem>} props.model
 * @param {number} props.activeIndex
 * @param {function} props.onTabChange
 * @param {string|null} props.id
 */
export default function TabMenu({
  model,
  activeIndex,
  onTabChange,
  id = null,
}) {
  const reactId = useId();

  return (
    <div id={id || reactId} className="border-bottom-1 border-300">
      <ul className="grid list-none gap-2 pl-2">
        {model.map((item, index) => (
          <li
            key={index}
            onClick={() => onTabChange(index)}
            className={classNames(
              "cursor-pointer px-3 py-1 border-round-lg transition-all transition-duration-150 col-2 flex align-items-center justify-content-center",
              {
                "bg-primary text-white font-bold": activeIndex === index,
                "border-1 border-solid border-primary": activeIndex !== index,
              }
            )}
            style={{
              width: "15%",
            }}
          >
            <span className="text-center">
              {item.icon && <i className={`${item.icon} inline`}></i>}
              {item.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
